export default "__VITE_ASSET__BCKUBHbZ__"